import { jsxs, jsx } from "react/jsx-runtime";
const IconMicrophoneSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M19 12a1 1 0 1 0-2 0c0 2.757-2.243 5-5 5s-5-2.243-5-5a1 1 0 1 0-2 0c0 3.519 2.614 6.432 6 6.92V20H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-1.08c3.386-.488 6-3.401 6-6.92Z" }),
      /* @__PURE__ */ jsx("path", { d: "M12 16c2.206 0 4-1.794 4-4V6c0-2.206-1.794-4-4-4S8 3.794 8 6v6c0 2.206 1.794 4 4 4ZM10 6c0-1.103.897-2 2-2s2 .897 2 2v6c0 1.103-.897 2-2 2s-2-.897-2-2V6Z" })
    ]
  }
);
export {
  IconMicrophoneSvg
};
